import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import CreateNewProfilesUploadFormExplanationBanner from '../create-new-profiles-upload-form-explanation-banner/CreateNewProfilesFormExplanationBanner';
import CreateNewProfilesUploadFormControls from './components/create-new-profiles-upload-form-controls/CreateNewProfilesUploadFormControls';
import CreateNewProfilesEntitiesList from '../create-new-profiles-entities-list/CreateNewProfilesEntitiesList';

import { CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER } from 'modules/create-new-profiles/constants/common';

import './create-new-profiles-upload-form.scss';

import { State } from 'types';

interface Props {
  showEntityList: boolean
}

const CreateNewProfilesUploadForm = ({ showEntityList: showEntityForm }: Props): JSX.Element => {
  const containerClassName = classnames({
    'create-new-profiles-upload-form': true,
    'create-new-profiles-upload-form--default': !showEntityForm
  });

  if (showEntityForm) {
    return (
      <div className={containerClassName}>
        <CreateNewProfilesEntitiesList />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <div className="create-new-profiles-upload-form__controls-wrapper">
        <CreateNewProfilesUploadFormControls />
      </div>
      <div className="create-new-profiles-upload-form__banner-wrapper">
        <CreateNewProfilesUploadFormExplanationBanner />
      </div>
    </div>
  );
};

const mapStateToProps = ({ createNewProfiles }: State): Props => ({
  showEntityList:
    createNewProfiles.createEntitiesModal.type === CREATE_NEW_PROFILES_MODAL_TEMPLATE_IDENTIFIER
    && createNewProfiles.createEntitiesModal.data?.type === 'successful-upload'
});

export default connect(mapStateToProps)(CreateNewProfilesUploadForm);
